<template>
  <div class="headPosiBox" :class="{ marbo: $route.name != 'homepage' }">
    <div class="installPrompt" v-if="isPluginInstalled">
      <div class="installPromptBox">
        <div class="conBox">
          <img
            class="RAGlogoImg"
            :src="require('@/assets/icon/rakumartandGoogle.svg')"
            alt=""
          />
          <span>{{
            $fanyi("安装Google购物插件后可通过图片在站内直接搜索")
          }}</span>
          <a
            href="https://chrome.google.com/webstore/detail/b%C3%BAsqueda-por-imagen-en-ra/ppgnkefpaocohpjnmldgigkpjccdikbe?utm_source=app-launcher&authuser=0"
            target="_blank"
            class="toGooGleShopBtn"
          >
            <download-plugin-icon class="linkIcon" />
            {{ $fanyi("安装Chrome扩展") }}
          </a>
          <div class="closeBtn" @click="closePromptClick">
            <img :src="require('@/assets/icon/closeWhite.png')" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div
      class="ImportHeaderBox"
      v-if="$route.name == 'homepage'"
      :class="{ 'ImportHeaderBox--hidden': isHeaderHidden }"
    >
      <div class="ImportHeaderBoxContainer">
        <div class="ImportHeaderBoxItem">
          {{ $fanyi("从中国进口最简单、最安全的方式") }}
        </div>

        <div class="ImportHeaderBoxItem">
          <div class="languageSwitchBox">
            <span
              :class="{ active: $store.state.fanyi }"
              @click="switchLanguage('zh')"
              >简体中文
            </span>
            <div>/</div>
            <span
              :class="{ active: !$store.state.fanyi }"
              @click="switchLanguage('it')"
              >Italiano</span
            >
          </div>
          <div class="chinaTimeBox">
            <div class="timeLabel">{{ $fanyi("中国时间") }}</div>
            <div class="timeSeparator"></div>
            <div class="timeValue">{{ chinaTime }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="headBox">
      <div class="headBoxContainer">
        <div class="logoBox">
          <router-link to="/">
            <img
              style="  width:210px;height: 52px;"
              id="logo"
              @click="backHome"
              src="../../assets/hometop/logo-rakumart-europe.svg"
              alt=""
          /></router-link>
        </div>
        <div class="textSearchBox dip jstart">
          <div class="inputBox dip">
            <div
              class="placeholderBox"
              v-if="!$store.state.searchInfo && showPlaceHold"
            >
              {{ $fanyi(placeholder1688UrlHtmlKey) }}
            </div>
            <input
              type="text"
              v-model="$store.state.searchInfo"
              @keydown.enter="search"
              @input="oninputMe"
            />
          </div>
          <button class="bgBlueBtn searchBtn dip" @click="search">
            <img
              src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202408/66d157f975e83.svg"
              alt=""
            />
          </button>
        </div>

        <div class="rightBox dip">
          <el-upload
            class="upImg"
            action="https://api.rakumart.it/api/common/uploadFile"
            :before-upload="befoUpload"
            :on-success="successup"
            :show-file-list="false"
            :http-request="httpup"
            accept=".jpg,.jpeg,.png"
          >
            <div class="imageSearch dip uiBtn uiGreen2">
              <image-search-icon class="imageSearchIcon" />
              <span>{{ $fanyi("通过图片搜索") }}</span>
            </div>
          </el-upload>

          <div class="imgBtnList dip">
            <div class="imgBtnBox dip cartBox" @click="openCart">
              <div class="cartNumBox" v-if="goodsNum > 0"></div>
              <img
                src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202408/66d01b752e26f.svg"
                alt=""
              />
            </div>

            <div
              class="imgBtnBox dip cartBox"
              @click="$fun.routerToPage('/user/inform')"
            >
              <div class="cartNumBox" v-if="count > 0"></div>
              <img
                src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202503/67d139e73c0bd.png"
                alt=""
              />
            </div>
          </div>

          <div class="userMenuBox">
            <div class="flex " v-if="userInfo">
              <div class="userHeaderBox dip">
                <img
                  style="cursor: pointer"
                  @click="$fun.routerToPage('/user/index')"
                  svg
                  :src="userInfo.head_img"
                  v-if="userInfo.head_img"
                />
                <img
                  style="cursor: pointer"
                  @click="$fun.routerToPage('/user/index')"
                  v-else
                  src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202408/66d0471f295cd.svg"
                />
              </div>

              <div class="userNameBox ">
                <div class="flex acenter">
                  <div class="nameFont">{{ userInfo.user_name }}</div>
                  <div class="idFont">(ID:{{ userInfo.user_id }})</div>
                </div>
                <div class="userMenuBtnBox dip">
                  <div
                    class="userMenuBoxItem"
                    @click="$fun.routerToPage('/user/index')"
                  >
                    <span>{{ $fanyi("个人中心") }}</span>
                  </div>
                  <span>/</span>
                  <div class="userMenuBoxItem outLogin" @click="loginOut">
                    <span>{{ $fanyi("退出登录") }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="loginBox" v-else>
              <el-button
                class="fontBlueBtn"
                @click="
                  $store.commit('getactivePage', $route.fullPath);
                  // $fun.routerToPage('/login');
                  $store.commit('getshowLoginDialog', true);
                "
                >{{ $fanyi("登录") }}</el-button
              >
              <el-button
                class="bgBlueBtn"
                @click="$fun.routerToPage('/Registrati')"
                >{{ $fanyi("注册") }}</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <otherOptionBox v-if="$route.name == 'homepage'" />
    <transition name="opacity-slide">
      <div class="upLoadShadow" v-show="loading"></div>
    </transition>
    <!-- 图片上传中模块 -->
    <div class="fileLoadingBox dip fdcolmun" v-if="loading">
      <div class="loadingIcon" v-loading="true"></div>
      <div class="tipBox">
        {{
          $fanyi(
            "我们正在寻找您的产品，并为您选择最好的供应商。温馨提示：请注意浏览器是否拦截了搜索结果界面的弹窗！！"
          )
        }}
      </div>
      <div class="smallTipBox">
        {{ $fanyi("请稍等。") }}
      </div>
    </div>
  </div>
</template>

<script>
import ClassificationOfGoodsVue from "../homePage/ClassificationOfGoods.vue";
import otherOptionBox from "./components/otherOptionBox.vue";
import sideBar from "../homePage/sideBar.vue";
import DownloadPluginIcon from "@/components/icons/DownloadPluginIcon.vue";
import ImageSearchIcon from "@/components/icons/ImageSearchIcon.vue";
export default {
  data() {
    return {
      placeholder1688UrlHtmlKey: "请输入关键词或1688/alibaba商品链接",
      logininfo: localStorage.getItem("logininfo"),
      value: "",
      showQita: true, //显示其他
      closePrompt: document.cookie.indexOf("closePrompt") != -1,
      isPluginInstalled: false,
      imageId: "",
      tipagedata: "",
      loading: false,
      showPlaceHold: true, //输入框显示placehold控制
      count: 0,
      chinaTime: "", // 中国时间
      timeInterval: null, // 定时器
      isHeaderHidden: false, // 控制顶部和optionContainerBox的显示/隐藏
      lastScrollTop: 0,
      scrollThreshold: 10,
    };
  },
  created() {
    // document.cookie = "closePrompt=true";
    // document.cookie = "closePrompt=; expires=Thu, 01 Jan 1970 00:00:00 GMT";//删除cookie
    // console.log(document.cookie.indexOf("closePrompt") != -1);
    // 防止搜索栏分类在跳转页面时因重新加载而清空
    this.value = this.$store.state.goodsListActiveId;
    this.$store.dispatch("goodsToCartNum");
    this.getNoticeUnreadNoticeCount();
    setTimeout(() => {
      this.isPluginInstalled =
        !document.getElementById("rakumart-plugin-dom") && !this.closePrompt;
    }, 300);

    // 初始化中国时间
    this.updateChinaTime();
    // 设置定时器，每秒更新一次时间
    this.timeInterval = setInterval(this.updateChinaTime, 1000);
  },
  components: {
    sideBar,
    ClassificationOfGoodsVue,
    otherOptionBox,
    DownloadPluginIcon,
    ImageSearchIcon,
  },
  computed: {
    searchInfo() {
      return this.$store.state.searchInfo;
    },
    goodsNum() {
      return this.$store.state.cartCount;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    options() {
      return this.$store.state.goodsList;
    },
    token() {
      if (this.$store.state.userInfo) {
        return true;
      } else {
        return false;
      }
    },
    /** 首页顶部分类栏 + 商品搜索页（含分类自定义路由）均显示分类导航 */
    showClassificationOfGoodsVue() {
      //console.log(this.$route.name);
      if (this.$fun.isCommoditySearchRoute(this.$route)) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  },

  beforeDestroy() {
    // 清理定时器
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    switchLanguage(language) {
      if (language == "zh") {
        this.$store.commit("changeData", true);
      } else {
        this.$store.commit("changeData", false);
      }
      window.location.reload();
    },
    /**
     * 更新中国时间
     */
    updateChinaTime() {
      const now = new Date();
      // 获取中国时区时间（UTC+8）
      const chinaTime = new Date(now.getTime() + 8 * 60 * 60 * 1000);

      // 格式化时间：YYYY-M-DD HH:mm:ss
      const year = chinaTime.getUTCFullYear();
      const month = chinaTime.getUTCMonth() + 1;
      const day = chinaTime.getUTCDate();
      const hours = chinaTime
        .getUTCHours()
        .toString()
        .padStart(2, "0");
      const minutes = chinaTime
        .getUTCMinutes()
        .toString()
        .padStart(2, "0");
      const seconds = chinaTime
        .getUTCSeconds()
        .toString()
        .padStart(2, "0");

      this.chinaTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 关闭推广
    closePromptClick() {
      this.isPluginInstalled = false;
      this.closePrompt = true;
      document.cookie = "closePrompt=true";
    },
    openCart() {
      if (localStorage.getItem("user_token")) {
        this.$fun.routerToPage("/Carrello");
      } else {
        this.$store.commit("getactivePage", "/Carrello");
        this.$store.commit("getshowLoginDialog", true); //打开登录弹窗
      }
    },
    getUser() {
      this.$api.EuropegetUserInfo().then((res) => {
        this.$store.commit("userData", res.data);
      });
    },

    // 返回首页
    backHome() {
      this.$store.commit("getsearchInfo", "");
    },
    // 跳转搜索页
    search() {
      let regtaobao = RegExp(/taobao/);
      let reg1688 = RegExp(/1688/);
      let regtmall = RegExp(/tmall/);
      let regrakumart = RegExp(/goods_id/);
      let id = "";
      var reg1 = /1688.com\/offer\/([0-9]+)/;
      var reg4 = /m\.1688\.com.*offerId=([0-9]{10,})/; //1688手机
      var reg2 = /[?|&]id=(\d{10,15})/;
      var reg3 = /[?|&]goods_id=(\d{10,15})/;
      // 阿里巴巴国际站等：支持多种 alibaba/1688 域名与路径变体（含 _商品id.html）
      var regAlibabaRobust = /(?:alibaba\.com|1688\.com).*?[_-](\d{8,20})(?:\.html|\/|$|&)/;
      var regAlibabaHtmlIds = /_(\d{8,20})\.html/g;
      // 识别本站 ProductDetails 链接
      var regProductDetails = /ProductDetails.*[?&]goods_id=(\d+)/;
      var regShopType = /[?&]shopType=([^&]+)/;
      // 判断是哪个网站的商品链接
      if (regProductDetails.test(this.$store.state.searchInfo)) {
        id = this.$store.state.searchInfo.match(regProductDetails)[1];
        let shopTypeMatch = this.$store.state.searchInfo.match(regShopType);
        let shopType = shopTypeMatch ? shopTypeMatch[1] : "1688";
        this.$fun.toCommodityDetails(id, { from_platform: shopType });
        return false;
      } else if (regtaobao.test(this.$store.state.searchInfo)) {
        id = this.$store.state.searchInfo.match(reg2)[1];
        this.$fun.toCommodityDetails(id, { from_platform: "taobao" });
        return false;
      } else if (
        reg1688.test(this.$store.state.searchInfo) &&
        (this.$store.state.searchInfo.indexOf("offer") != -1 ||
          this.$store.state.searchInfo.indexOf("offerId") != -1)
      ) {
        if (this.$store.state.searchInfo.match(reg1) == null) {
          id = this.$store.state.searchInfo.match(reg4)[1];
        } else {
          id = this.$store.state.searchInfo.match(reg1)[1];
        }
        this.$fun.toCommodityDetails(id, { from_platform: "1688" });
        return false;
      } else if (
        /alibaba\.com/i.test(this.$store.state.searchInfo) ||
        /1688\.com/i.test(this.$store.state.searchInfo)
      ) {
        let urlStr = this.$store.state.searchInfo;
        let mRobust = urlStr.match(regAlibabaRobust);
        id = mRobust ? mRobust[1] : "";
        if (!id) {
          const ids = [];
          let m;
          while ((m = regAlibabaHtmlIds.exec(urlStr)) !== null) {
            ids.push(m[1]);
          }
          id = ids.length ? [...new Set(ids)][0] : "";
        }
        if (id) {
          this.$fun.toCommodityDetails(id, { from_platform: "alibaba" });
          return false;
        }
      } else if (regtmall.test(this.$store.state.searchInfo)) {
        id = this.$store.state.searchInfo.match(reg2)[1];
        this.$fun.toCommodityDetails(id, { from_platform: "tmall" });
        return false;
      } else if (regrakumart.test(this.$store.state.searchInfo)) {
        // return false;
        id = this.$store.state.searchInfo.match(reg3)[1];
        this.$fun.toCommodityDetails(id, { from_platform: "tmall" });
      }
      // --------------------------------------------------
      // 设置分类选择框的已选中id
      let selId = this.value
        ? this.options.find((item) => item.chinese_name == this.value).id
        : "";
      // 在搜索页重新搜索时：若分类选择器 id 与当前路由分类不一致，重置为普通关键词搜索
      if (
        this.$fun.isCommoditySearchRoute(this.$route) &&
        selId !=
          (this.$route.query.group_id ||
            (this.$route.meta.shopGroupCategory &&
              this.$route.meta.shopGroupCategory.id))
      ) {
        // 分类与当前路由不一致时，重置为纯关键词搜索（routerToPage 只接受字符串 URL，不能传 { query }）
        this.$fun.routerToPage(
          "/CommoditySearch?keyword=" + this.$store.state.searchInfo
        );
        return false;
      }
      // 同一关键词重复搜索时刷新；分类路由用 meta.translation_name 比较
      if (
        this.$store.state.searchInfo ==
        (this.$route.query.keyword ||
          (this.$route.meta.shopGroupCategory &&
            this.$route.meta.shopGroupCategory.translation_name))
      ) {
        this.$router.go(0);
        return false;
      }
      // 如果关键词为空就不跳转
      if (!this.$store.state.searchInfo) {
        this.$message(this.$fanyi("请输入关键词搜索"));
        return false;
      }
      // 跳转
      this.$fun.routerToPage(
        "/CommoditySearch?keyword=" +
          this.$store.state.searchInfo +
          "&group_id=" +
          selId,
        true
      );
    },
    oninputMe(e) {
      if (!e.srcElement.value) {
        this.showPlaceHold = true;
      } else {
        this.showPlaceHold = false;
      }
    },
    // 退出登录
    loginOut() {
      localStorage.removeItem("backgroundOperationID");
      sessionStorage.removeItem("backendPersonnel");
      localStorage.removeItem("user_token");
      sessionStorage.removeItem("user_id");

      this.$store.commit("userData", null);
      this.$store.commit("setcartCount", 0);
      let requireAuth = this.$route.matched[0].meta.requireAuth;
      if (requireAuth) {
        this.$fun.routerToPage("/");
      } else {
        this.$router.go(0);
      }
    },
    befoUpload(file) {
      const isJPG =
        ["image/jpeg", "image/png", "image/jpg"].indexOf(file.type) != -1;
      //console.log(file.type);
      if (!isJPG) {
        this.$message.error(this.$fanyi("请上传图片"));
        return isJPG;
      }

      this.loading = true;
    },
    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },

    // 图片上传事件
    httpup(file) {
      var _this = this;
      this.imageId = "";
      this.tipagedata = "";
      const TARGET_SIZE = 300 * 1024;
      const rawFile = file.file;

      console.log("原始文件大小:", (rawFile.size / 1024).toFixed(2) + "KB");
      if (rawFile.size <= TARGET_SIZE) {
        _this.processUploadFile(rawFile);
        return;
      }

      const reader = new FileReader();
      reader.onload = function(e) {
        const img = new Image();
        img.onload = function() {
          const ratio = TARGET_SIZE / rawFile.size;
          let scale = Math.sqrt(ratio);
          let w = Math.max(1, Math.round(img.width * scale));
          let h = Math.max(1, Math.round(img.height * scale));

          const canvas = document.createElement("canvas");
          canvas.width = w;
          canvas.height = h;
          canvas.getContext("2d").drawImage(img, 0, 0, w, h);

          canvas.toBlob(function(blob) {
            console.log(
              "尺寸压缩后:",
              (blob.size / 1024).toFixed(2) + "KB",
              "尺寸=" + w + "x" + h
            );
            if (blob.size <= TARGET_SIZE) {
              const compressedFile = new File([blob], rawFile.name, {
                type: blob.type || rawFile.type,
                lastModified: Date.now(),
              });
              _this.processUploadFile(compressedFile);
              return;
            }
            const q = Math.min(
              0.92,
              Math.max(0.1, Math.sqrt(TARGET_SIZE / blob.size))
            );
            canvas.toBlob(
              function(blob2) {
                console.log(
                  "质量压缩后:",
                  (blob2.size / 1024).toFixed(2) + "KB",
                  "quality=" + q.toFixed(2)
                );
                const jpegName = rawFile.name.replace(/\.(png|webp)$/i, ".jpg");
                const compressedFile = new File([blob2], jpegName, {
                  type: "image/jpeg",
                  lastModified: Date.now(),
                });
                _this.processUploadFile(compressedFile);
              },
              "image/jpeg",
              q
            );
          }, rawFile.type);
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(rawFile);
    },
    // 处理上传文件
    processUploadFile(fileToUpload) {
      this.blobToBase64(fileToUpload).then((reader) => {
        this.getImageId(reader);
      });
      this.$fun.httpRequest(
        fileToUpload,
        (res) => {
          this.tipagedata = res.data;
          this.successup();
        },
        false
      );
    },

    //获取图片id
    getImageId(val) {
      let that = this;
      let index = val.indexOf("base64,");
      let base64String = val.substr(index + 7, val.length);
      console.log(
        "getImageId base64大小:",
        ((base64String.length * 0.75) / 1024).toFixed(2) + "KB"
      );

      // 构造上传参数
      let datas = {
        url: "/1/com.alibaba.fenxiao.crossborder/product.image.upload",
        uploadImageParam: JSON.stringify({
          imageBase64: base64String,
        }),
      };

      // 调用上传接口
      that.$api
        .uploadImagePic(datas)
        .then((res) => {
          if (!res.data || res.data.code != 200) {
            that.loading = false;
            return that.$message.error(
              that.$fanyi(res.data?.message || "图片上传失败")
            );
          }
          that.imageId = res.data.result;
          that.successup();
        })
        .catch(() => {
          that.loading = false;
        });
    },

    // 图片上传成功事件
    successup() {
      console.log(this.imageId, this.tipagedata);
      if (this.imageId && this.tipagedata) {
        this.loading = false;
        this.$store.commit("getsearchImg", this.tipagedata);

        this.$fun.routerToPage(
          "/CommoditySearch?type=imgSearch&imgUrl=" +
            this.tipagedata +
            "&imageId=" +
            this.imageId,
          true
        );
      }
      return;
    },

    getNoticeUnreadNoticeCount() {
      //favoriteGoodsList
      this.$api
        .noticeUnreadNotice()
        .then((res) => {
          this.count = res.data.length;
        })
        .catch((err) => {});
    },

    // 滚动监听
    handleScroll() {
      // if (router.history.current.fullPath == "/") {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop >= 400) {
        this.isHeaderHidden = true;
        // document.getElementById("classBox").style.display = "none";
      } else if (scrollTop <= 100) {
        this.isHeaderHidden = false;
      }

      return;
      // const scrollTop =
      //   window.pageYOffset || document.documentElement.scrollTop;
      // const diff = scrollTop - this.lastScrollTop;
      // if (Math.abs(diff) > this.scrollThreshold) {
      //   if (diff > 0) {
      //     // 向下滚动
      //     this.isHeaderHidden = true;
      //   } else {
      //     // 向上滚动
      //     this.isHeaderHidden = false;
      //   }
      // }
      // this.lastScrollTop = scrollTop;
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";

.headPosiBox {
  position: sticky;
  top: 0;
  z-index: 10;
  min-width: 1440px;
}

.marbo {
  margin-bottom: 20px;
}

.installPrompt {
  $height: 54px;
  height: $height;
  width: 100%;

  .installPromptBox {
    height: $height;
    top: 0;
    position: fixed;
    width: 100%;
    z-index: 110;
    background: linear-gradient(
      270deg,
      #55d1ff 0%,
      #a1f1e3 42%,
      #b6e2ff 62%,
      #55d1ff 100%
    );

    .conBox {
      width: 1400px;
      height: $height;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      .RAGlogoImg {
        width: 73px;
        height: 30px;
        margin-right: 13px;
      }

      span {
        font-size: 14px;
        font-weight: 600;
        margin-right: 13px;
        margin-bottom: 2px;
      }

      .toGooGleShopBtn {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        width: 256px;
        height: 27px;
        font-size: 13px;
        font-weight: 600;
        background: #fdc100;
        border-style: solid;
        border-radius: 6px;
        border-color: #fdc100;
        transition: 0.3s;
        color: #344054 !important;
        text-decoration: none !important;

        .linkIcon {
          fill: #009246;
          margin-right: 5px;
          transform: translateY(1px);
          font-weight: bold;
          transition: 0.3s;
        }

        &:hover {
          background: #e0aa00;
          border-color: #e0aa00;

          .linkIcon {
          }
        }
      }

      .closeBtn {
        position: fixed;
        cursor: pointer;
        top: 17px;
        right: 20px;

        img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
}

.headBox {
  height: 96px;
  @extend .dip;
  padding: 32px 48px;
  background-color: white;

  .headBoxContainer {
    width: 1400px;
    @extend .dip;
  }

  .logoBox {
    margin-right: 32px;
    flex-shrink: 0;
  }

  .textSearchBox {
    flex: 1;
    min-width: 0;
    max-width: 640px;
    height: 44px;

    .inputBox {
      flex: 1;
      min-width: 0;
      height: 45px;
      border-radius: 8px 0 0 8px;
      border: 1px solid #e3e3e3;
      background: #fff;

      padding: 0 16px;
      position: relative;

      .iconBox {
        margin-right: 16px;
      }

      input {
        flex: 1;
        height: 45px;
        border: none;
        background-color: transparent;
        position: relative;
        font-size: 16px;
        z-index: 1;
      }

      .placeholderBox {
        position: absolute;
        left: 16px;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 14px;
        line-height: 1;
        color: #c0c4cc;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        pointer-events: none;
      }
    }

    .searchBtn {
      width: 45px;
      height: 45px;
      transition: 0.3s;
      border-radius: 0px 8px 8px 0px;

      span {
        display: block;
        width: 0;
        overflow: hidden;
        font-size: 16px;
        white-space: nowrap;
        transition: 0.3s;
      }
    }
  }

  .rightBox {
    flex-shrink: 0;
    margin-left: 24px;

    .imageSearch {
      padding: 12px 24px;
      gap: 10px;
      border-radius: 128px;
      transition: 0.3s;
      position: relative;

      span {
        color: inherit;
        font-size: 16px;
        font-weight: 700;
      }
    }

    .imgBtnList {
      margin-right: 30px;
      margin-left: auto;

      .imgBtnBox {
        $size: 40px;
        width: $size;
        height: $size;
        cursor: pointer;
      }

      .cartBox {
        position: relative;

        .cartNumBox {
          position: absolute;
          top: 3px;
          right: 1px;
          background-color: #75ba2a;
          width: 10px;
          height: 10px;
          font-size: 12px;
          border-radius: 50%;
        }
      }
    }

    .userMenuBox {
      .userHeaderBox {
        width: 46px;
        height: 46px;
        overflow: hidden;
        border-radius: 50%;
        margin-right: 16px;

        img {
          width: 100%;
        }
      }

      .userNameBox {
        height: 18px;

        .nameFont {
          font-size: 18px;
          font-weight: 600;
          margin-right: 6px;
          max-width: 144px;

          height: 28px;
          @extend .text-overflow-one;
        }

        .idFont {
          color: #667085;
          font-size: 16px;
        }

        .rateIcon {
          transition: 0.3s;
          rotate: 180deg;
          margin-right: 10px;
        }

        .rateIcon.hoverIn {
          rotate: 0deg;
        }
      }

      .userMenuBtnBox {
        font-size: 16px;
        line-height: 16px;
        gap: 6px;
        color: #667085;

        .userMenuBoxItem {
          cursor: pointer;
        }

        .outLogin {
          color: #009246;
        }
      }

      .loginBox {
        gap: 16px;

        .el-button {
          // min-width: 185px;
          font-size: 16px;
        }
      }
    }
  }
}

.upLoadShadow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba($color: #000000, $alpha: 0.5);
  z-index: 40;
}

.fileLoadingBox {
  position: fixed;
  z-index: 40;
  top: 37%;
  left: 50%;
  transform: translate(-50%);
  width: 749px;
  height: 230px;
  padding: 16px 22px;
  gap: 10px;
  background-color: white;
  border-radius: 16px;
  border: 2px solid var(--Gray-200, #eaecf0);
  background: #fff;
  /* Shadows/shadow-md */
  box-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.1),
    0px 2px 4px -2px rgba(16, 24, 40, 0.06);

  .loadingIcon {
    width: 48px;
    height: 48px;

    /deep/.el-loading-spinner .path {
      stroke: #009246;
    }
  }

  .tipBox {
    color: #013b2d;
    text-align: center;
    font-size: 18px;
    line-height: 28px;
    /* 155.556% */
  }

  .smallTipBox {
    color: var(--Gray-600, #475467);
    font-size: 13px;
    line-height: 20px;
    /* 142.857% */
  }
}

/* 进口头部样式 */
.ImportHeaderBox {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #eaf8e8;
  transition: all 0.3s ease;

  &.ImportHeaderBox--hidden {
    height: 0;
    overflow: hidden;
  }

  .ImportHeaderBoxContainer {
    width: 1400px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;

    .ImportHeaderBoxItem {
      font-size: 14px;
      color: #666;
      line-height: 1.4;
      display: flex;
      align-items: center;
      gap: 24px;

      .languageSwitchBox {
        display: flex;
        align-items: center;
        gap: 10px;

        span {
          cursor: pointer;
        }

        .active {
          color: #009246;
        }
      }

      /* 中国时间框样式 */
      .chinaTimeBox {
        display: flex;
        align-items: center;
        background: #fff;
        border: 1px solid #ccc;
        border-radius: 6px;
        padding: 8px 12px;
        min-width: 280px;

        .timeLabel {
          font-size: 14px;
          color: #667085;
        }

        .timeSeparator {
          width: 1px;
          height: 12px;
          background: #e0e0e0;
          margin: 0 10px;
        }

        .timeValue {
          font-size: 14px;
          color: #666;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
<style lang="scss"></style>
